import { render, staticRenderFns } from "./ProjectsClient.vue?vue&type=template&id=0a7a57c2&"
import script from "./ProjectsClient.vue?vue&type=script&lang=js&"
export * from "./ProjectsClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports